// import React, { useCallback } from 'react';
// import { Box, Typography, Button, Avatar } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import Particles from "react-tsparticles";
// import { loadFull } from "tsparticles";

// const API_BASE = process.env.REACT_APP_API_URL;

// function PrivateChatSelection({ userId, onlineUsers }) {
//   const navigate = useNavigate();

//   // 3D palette particles background
//   const particlesInit = useCallback(async (engine) => {
//     await loadFull(engine);
//   }, []);

//   return (
//     <Box
//       sx={{
//         position: 'relative',
//         minHeight: '100vh',
//         bgcolor: '#191931',
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         p: 2,
//         overflow: 'hidden'
//       }}
//     >
//       {/* 3D Palette Particle BG */}
//       <Particles
//         id="tsparticles"
//         init={particlesInit}
//         options={{
//           fullScreen: { enable: false },
//           background: { color: { value: "#191931" } },
//           fpsLimit: 60,
//           particles: {
//             number: { value: 70, density: { enable: true, area: 800 } },
//             color: { value: ["#62d6e8", "#9867f0", "#ffd166"] },
//             shape: { type: "circle" },
//             opacity: { value: 0.65, random: true },
//             size: { value: 3, random: true },
//             move: { enable: true, speed: 2, outModes: 'bounce' },
//             links: { enable: true, distance: 110, color: "#a3a3ff", opacity: 0.25, width: 2 }
//           },
//           interactivity: {
//             events: { onHover: { enable: true, mode: "repulse" } },
//             modes: { repulse: { distance: 100 } }
//           },
//           detectRetina: true,
//         }}
//         style={{
//           position: "absolute",
//           inset: 0,
//           width: "100vw",
//           height: "100vh",
//           zIndex: 0,
//         }}
//       />
//       <Box
//         sx={{
//           width: { xs: '90%', sm: 400 },
//           bgcolor: 'rgba(33, 33, 64, 0.95)',
//           borderRadius: 4,
//           boxShadow: '0 0 40px #7b5cf5cc',
//           p: 4,
//           color: '#fff',
//           zIndex: 1,
//         }}
//       >
//         <Typography
//           variant="h4"
//           gutterBottom
//           align="center"
//           sx={{ mb: 3, fontWeight: 700, letterSpacing: 1.2 }}
//         >
//           Select a user to chat with
//         </Typography>
//         {onlineUsers.length === 0 ? (
//           <Typography align="center" sx={{ opacity: 0.7 }}>
//             No users online.
//           </Typography>
//         ) : (
//           onlineUsers
//             .filter((u) => u.id !== userId)
//             .map((user) => (
//               <Button
//                 key={user.id}
//                 onClick={() => navigate(`/private/${user.id}`)}
//                 variant="outlined"
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'flex-start',
//                   mb: 2,
//                   width: '100%',
//                   fontWeight: 600,
//                   color: '#e0e0ff',
//                   borderColor: '#7b5cf5',
//                   textTransform: 'none',
//                   '&:hover': {
//                     bgcolor: '#7b5cf5',
//                     color: '#fff',
//                     borderColor: '#7b5cf5',
//                   },
//                 }}
//               >
//                 <Avatar
//                   src={user.profilePhoto ? `http://localhost:5000${user.profilePhoto}` : undefined}
//                   sx={{
//                     mr: 2,
//                     bgcolor: '#7b5cf5',
//                     fontWeight: 'bold',
//                   }}
//                 >
//                   {!user.profilePhoto && user.username.charAt(0).toUpperCase()}
//                 </Avatar>
//                 {user.username}
//               </Button>
//             ))
//         )}
//       </Box>
//     </Box>
//   );
// }

// export default PrivateChatSelection;


import React from 'react';
import { Box, Typography, Avatar } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_URL;

const avatarColor = (name = "") => {
  const c = ['#00C2B3', '#0088A3', '#007A70', '#005A6E'];
  let h = 0;
  for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
  return c[Math.abs(h) % c.length];
};

function PrivateChatSelection({ userId, onlineUsers }) {
  const navigate = useNavigate();
  const others = (onlineUsers || []).filter(u => u.id !== userId);

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#090C0F', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}>
      <Box sx={{ width: '100%', maxWidth: 420 }}>
        {/* Header */}
        <Box sx={{ mb: 4, textAlign: 'center' }}>
          <Typography sx={{
            fontFamily: "'Outfit', sans-serif", fontWeight: 700,
            fontSize: 26, color: '#F0F4F8', letterSpacing: '-0.02em', mb: 0.5,
          }}>
            New message
          </Typography>
          <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 14, color: '#3A4A58' }}>
            Select someone to start a private chat
          </Typography>
        </Box>

        {/* User list */}
        <Box sx={{
          bgcolor: '#0E1318', border: '1px solid #1A2228',
          borderRadius: '16px', overflow: 'hidden',
        }}>
          {/* Online count header */}
          <Box sx={{
            px: 3, py: 2, borderBottom: '1px solid #1A2228',
            display: 'flex', alignItems: 'center', gap: 2,
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#00C2B3' }} />
              <Typography sx={{
                fontFamily: "'Outfit', sans-serif", fontWeight: 600, fontSize: 13,
                color: '#A0B0BF', textTransform: 'uppercase', letterSpacing: '0.06em',
              }}>
                Online — {others.length}
              </Typography>
            </Box>
          </Box>

          {others.length === 0 ? (
            <Box sx={{ px: 3, py: 5, textAlign: 'center' }}>
              <Typography sx={{ fontSize: 32, mb: 1.5 }}>👻</Typography>
              <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 15, color: '#3A4A58', fontWeight: 500 }}>
                No other users online right now
              </Typography>
              <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, color: '#2A3A48', mt: 0.5 }}>
                Check back later
              </Typography>
            </Box>
          ) : (
            others.map((user, i) => (
              <Box
                key={user.id}
                onClick={() => navigate(`/private/${user.id}`)}
                sx={{
                  display: 'flex', alignItems: 'center', gap: 2,
                  px: 3, py: 2,
                  borderBottom: i < others.length - 1 ? '1px solid #1A2228' : 'none',
                  cursor: 'pointer',
                  transition: 'all 0.12s',
                  '&:hover': { bgcolor: '#111820' },
                }}
              >
                <Box sx={{ position: 'relative' }}>
                  <Avatar
                    src={user.profilePhoto ? `${API_BASE}${user.profilePhoto}` : undefined}
                    sx={{
                      width: 42, height: 42, fontSize: 15, fontWeight: 700,
                      bgcolor: avatarColor(user.username),
                    }}
                  >
                    {!user.profilePhoto && user.username?.[0]?.toUpperCase()}
                  </Avatar>
                  <Box sx={{
                    position: 'absolute', bottom: 1, right: 1,
                    width: 10, height: 10, bgcolor: '#00C2B3',
                    borderRadius: '50%', border: '2px solid #0E1318',
                  }} />
                </Box>

                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography sx={{
                    fontFamily: "'Outfit', sans-serif", fontWeight: 600, fontSize: 15, color: '#F0F4F8',
                  }}>
                    {user.username}
                  </Typography>
                  <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 12, color: '#00C2B3' }}>
                    Active now
                  </Typography>
                </Box>

                <Box sx={{
                  width: 28, height: 28, borderRadius: '8px',
                  bgcolor: '#141B22', border: '1px solid #1A2228',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: '#3A4A58',
                }}>
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                    <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </Box>
              </Box>
            ))
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default PrivateChatSelection;